import { Action } from '@ngrx/store';

export enum ActionTypes {

    // Scheduler - GET
    GET_SCHEDULER = '[Scheduler] Get Scheduler',
    GET_SCHEDULER_SUCCESS = '[Scheduler] Get Scheduler Success',
    GET_SCHEDULER_FAIL = '[Scheduler] Get Scheduler Fail',

    // Scheduler - POST
    CREATE_SCHEDULER = '[Scheduler] Create Scheduler',
    CREATE_SCHEDULER_SUCCESS = '[Scheduler] Create Scheduler Success',
    CREATE_SCHEDULER_FAIL = '[Scheduler] Create Scheduler Fail',

    // Scheduler - PATCH
    UPDATE_SCHEDULER = '[Scheduler] Update Scheduler',
    UPDATE_SCHEDULER_SUCCESS = '[Scheduler] Update Scheduler Success',
    UPDATE_SCHEDULER_FAIL = '[Scheduler] Update Scheduler Fail',

    // Scheduler - DELETE
    DELETE_SCHEDULER = '[Scheduler] Delete Scheduler',
    DELETE_SCHEDULER_SUCCESS = '[Scheduler] Delete Scheduler Success',
    DELETE_SCHEDULER_FAIL = '[Scheduler] Delete Scheduler Fail',


}






// SCHEDULER GET
export class GetScheduler implements Action {
    readonly type = ActionTypes.GET_SCHEDULER;
    constructor(public companyId,public storyId: number, public payload?: any) {}
  }
  
  export class GetSchedulerSuccess implements Action {
    readonly type = ActionTypes.GET_SCHEDULER_SUCCESS;
    constructor(public payload: any) {}
  }
  
  export class GetSchedulerFailure implements Action {
    readonly type = ActionTypes.GET_SCHEDULER_FAIL;
  }
  
  // SCHEDULER POST (CREATE)
  export class CreateScheduler implements Action {
    readonly type = ActionTypes.CREATE_SCHEDULER;
    constructor(public companyId,public storyId: number, public payload?: any) {}
  }
  
  export class CreateSchedulerSuccess implements Action {
    readonly type = ActionTypes.CREATE_SCHEDULER_SUCCESS;
  }
  
  export class CreateSchedulerFailure implements Action {
    readonly type = ActionTypes.CREATE_SCHEDULER_FAIL;
  }
  
  // SCHEDULER PATCH (UPDATE)
  export class UpdateScheduler implements Action {
    readonly type = ActionTypes.UPDATE_SCHEDULER;
    constructor(public companyId,public storyId: number, public payload: any) {}
  }
  
  export class UpdateSchedulerSuccess implements Action {
    readonly type = ActionTypes.UPDATE_SCHEDULER_SUCCESS;
  }
  
  export class UpdateSchedulerFailure implements Action {
    readonly type = ActionTypes.UPDATE_SCHEDULER_FAIL;
  }
  
  // SCHEDULER DELETE
  export class DeleteScheduler implements Action {
    readonly type = ActionTypes.DELETE_SCHEDULER;
    constructor(public companyId, public storyId: number) {}
  }
  
  export class DeleteSchedulerSuccess implements Action {
    readonly type = ActionTypes.DELETE_SCHEDULER_SUCCESS;
  }
  
  export class DeleteSchedulerFailure implements Action {
    readonly type = ActionTypes.DELETE_SCHEDULER_FAIL;
  }
  



export type Actions =
     GetScheduler
    | GetSchedulerSuccess
    | GetSchedulerFailure
    | CreateScheduler
    | CreateSchedulerSuccess
    | CreateSchedulerFailure
    | UpdateScheduler
    | UpdateSchedulerSuccess
    | UpdateSchedulerFailure
    | DeleteScheduler
    | DeleteSchedulerSuccess
    | DeleteSchedulerFailure;